var map = {
	"./Twillio.svg": 24950,
	"./aibe.svg": 47259,
	"./arrow.svg": 69927,
	"./chain.svg": 4586,
	"./facebook.svg": 28246,
	"./general_integration.svg": 33096,
	"./google-analytics.svg": 83440,
	"./google_google.svg": 88521,
	"./linkmobility.svg": 81087,
	"./nav-chrome.svg": 1922,
	"./nav-edge.svg": 31497,
	"./nav-firefox.svg": 35721,
	"./nav-generico.svg": 21456,
	"./nav-iexplorer.svg": 49787,
	"./nav-opera.svg": 81494,
	"./nav-safari.svg": 49746,
	"./nav-sidekick.svg": 30844,
	"./sms.svg": 13937,
	"./so-generico.svg": 65823,
	"./so-linux.svg": 86366,
	"./so-macos.svg": 70940,
	"./so-windows.svg": 23106,
	"./tiktok.svg": 29064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53031;